var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card-body mt-4"},[_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"350","series":_vm.salesDataSeries,"options":_vm.salesDataOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }